import { KLAVIYO_EVENTS_NAME } from '../events-name/klaviyo-events-name';

// doc: https://developers.klaviyo.com/en/docs/introduction_to_the_klaviyo_object#update-_learnq-code-to-use-klaviyo

export const trackKlaviyo = (event: string, properties: Record<string, any>) => {
  if (typeof window !== 'undefined' && typeof _learnq !== 'undefined') {
    if (event === KLAVIYO_EVENTS_NAME.KL_IDENTIFY) {
      _learnq.push(['identify', properties]);
    } else {
      _learnq.push(['track', event, properties]);
    }
  }
};
